import { createContext, useContext } from "react"

export const IsEditingContext = createContext(false)

export function useIsEditing() {
    return useContext(IsEditingContext)
}
